var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "results" }, [
      !_vm.embedded
        ? _c(
            "div",
            { staticClass: "sort-bar" },
            [
              _c("div", { staticClass: "displaying" }, [
                _vm._v("\n\t\t\t\tShowing "),
                _c("strong", [_vm._v(_vm._s(_vm.numOnDisplay))]),
                _vm._v(" of "),
                _c("strong", [_vm._v(_vm._s(_vm.results.length))]),
                _vm._v(" result"),
                _vm.results.length > 1 ? _c("span", [_vm._v("s")]) : _vm._e()
              ]),
              _vm._v(" "),
              _c("sort")
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "results-grid" },
        [
          _vm._l(_vm.promotionalResults, function(promotionalResult, key) {
            return _vm.promotionalResults.length > 0
              ? _c("result", {
                  key: "promo-" + key,
                  attrs: { result: promotionalResult }
                })
              : _vm._e()
          }),
          _vm._v(" "),
          _vm._l(_vm.displayedResults, function(result, index) {
            return _c("result", { key: index, attrs: { result: result } })
          })
        ],
        2
      )
    ]),
    _vm._v(" "),
    !_vm.embedded
      ? _c("div", { staticClass: "navigation" }, [
          _c("div", { staticClass: "page-total" }, [
            _vm._v("\n\t\t\tItems per page\n\t\t\t"),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.perPage,
                    expression: "perPage"
                  }
                ],
                on: {
                  change: [
                    function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.perPage = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                    function($event) {
                      _vm.currentPage = 1
                    }
                  ]
                }
              },
              _vm._l(_vm.pageOptions, function(option) {
                return _c("option", { domProps: { value: option } }, [
                  _vm._v(_vm._s(option))
                ])
              }),
              0
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "page-count" }, [
            _vm._v(
              "Page " + _vm._s(_vm.currentPage) + " of " + _vm._s(_vm.maxPages)
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "page-nav" },
            [
              _vm.currentPage > 2
                ? _c(
                    "span",
                    {
                      on: {
                        click: function($event) {
                          _vm.currentPage = 1
                          _vm.$emit("scrollToTop")
                        }
                      }
                    },
                    [_vm._v("First")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.currentPage !== 1
                ? _c(
                    "span",
                    {
                      on: {
                        click: function($event) {
                          _vm.currentPage--
                          _vm.$emit("scrollToTop")
                        }
                      }
                    },
                    [_vm._v("<<")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("span", { staticClass: "nav-active" }, [
                _vm._v(_vm._s(_vm.currentPage))
              ]),
              _vm._v(" "),
              _vm._l(
                _vm.pages.slice(_vm.currentPage, _vm.currentPage + 2),
                function(pageNumber) {
                  return _c(
                    "span",
                    {
                      on: {
                        click: function($event) {
                          _vm.currentPage = pageNumber
                          _vm.$emit("scrollToTop")
                        }
                      }
                    },
                    [_vm._v(_vm._s(pageNumber))]
                  )
                }
              ),
              _vm._v(" "),
              _vm.currentPage < _vm.pages.length
                ? _c(
                    "span",
                    {
                      on: {
                        click: function($event) {
                          _vm.currentPage++
                          _vm.$emit("scrollToTop")
                        }
                      }
                    },
                    [_vm._v(">>")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.pages.length > 2
                ? _c(
                    "span",
                    {
                      on: {
                        click: function($event) {
                          _vm.currentPage = _vm.maxPages
                          _vm.$emit("scrollToTop")
                        }
                      }
                    },
                    [_vm._v("Last")]
                  )
                : _vm._e()
            ],
            2
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }